module.exports = __webpack_public_path__ + "static/media/5.d82f550e.jpg";